import { Stack, Container, Typography, Box, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { ForgotForm } from 'src/sections/authentication/forgot';
import AuthBrandPanel from '../components/authentication/AuthBrandPanel';
import { AuthRootStyle, AuthSectionStyle, AuthContentStyle } from '../components/authentication/authLayoutStyles';

export default function Forgot() {
  return (
    <AuthRootStyle title={`Forgot password | ${process.env.REACT_APP_PROJECTNAME}`}>
      <AuthSectionStyle sx={{ display: { xs: 'none', md: 'flex' } }}>
        <AuthBrandPanel />
      </AuthSectionStyle>

      <Container maxWidth="sm">
        <AuthContentStyle>
          <Box sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'center', mb: 4 }}>
            <AuthBrandPanel compact />
          </Box>

          <Stack sx={{ mb: 3 }}>
            <Typography className="heading_center" sx={{ color: '#F3F4F6 !important' }} variant="h4" gutterBottom>
              Forgot password
            </Typography>
            <Typography className="heading_center" sx={{ color: '#9CA3AF !important' }}>
              Enter your registered email. We will send a reset code to your inbox.
            </Typography>
          </Stack>

          <ForgotForm />

          <Typography sx={{ mt: 3, textAlign: 'center', color: '#9CA3AF' }}>
            <Link component={RouterLink} to="/login" underline="hover" sx={{ color: '#3F90DF' }}>
              Back to login
            </Link>
          </Typography>
        </AuthContentStyle>
      </Container>
    </AuthRootStyle>
  );
}
